import { render, staticRenderFns } from "./OfficersMap.vue?vue&type=template&id=54379f96&"
import script from "./OfficersMap.vue?vue&type=script&lang=js&"
export * from "./OfficersMap.vue?vue&type=script&lang=js&"
import style0 from "./OfficersMap.vue?vue&type=style&index=0&id=54379f96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports